import React from 'react';
import styled, { css } from 'styled-components';
import { IoIosCheckmark } from 'react-icons/io';
import { CommonText } from '../bumpViews/commonText';
const OptionItemWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid transparent;
  ${({ active }) => {
    if (active) {
        return css `
        border: 1px solid #fb2f2f;
        background: #fff3f3;
      `;
    }
    return css `
      background: #f5f5f5;
    `;
}}
`;
export const OptionItem = ({ id, text, isActive, onClick }) => {
    return (React.createElement(OptionItemWrapper, { id: id, active: isActive, onClick: onClick },
        React.createElement(CommonText, { size: "semiMedium", weight: 500, color: isActive ? '#FB2F2F' : '#4B4F5E' }, text),
        isActive && React.createElement(IoIosCheckmark, { width: 14, height: 14, color: isActive ? '#FB2F2F' : '#4B4F5E' })));
};
//# sourceMappingURL=index.js.map